import { FormattedMessage, useIntl } from 'react-intl'
import { ModalWrapper, ModalHeader, ModalContent, ModalRow } from './styles'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { darkMode } from 'styles/theme'
import { useMemo } from 'react'
import Modal from 'components/shared/Modal'

interface DifferentHoursProps {
    isOpened: boolean
    close: () => void
}

const BirthdayPromotionModal = ({ isOpened, close }: DifferentHoursProps) => {
    const { formatMessage } = useIntl()

    const tabelData = useMemo(
        () => [
            {
                label: formatMessage({
                    id: 'promo.birthday.discounts_01',
                    defaultMessage: 'Luty',
                }),
                discount: '-15%',
            },
            {
                label: formatMessage({
                    id: 'promo.birthday.discounts_02',
                    defaultMessage: 'Marzec',
                }),
                discount: '-25%',
            },
            {
                label: formatMessage({
                    id: 'promo.birthday.discounts_03',
                    defaultMessage: 'Kwiecień - Czerwiec',
                }),
                discount: '-35%',
            },
            {
                label: formatMessage({
                    id: 'promo.birthday.discounts_04',
                    defaultMessage: 'Lipiec - Sierpień',
                }),
                discount: '-25%',
            },
            {
                label: formatMessage({
                    id: 'promo.birthday.discounts_05',
                    defaultMessage: 'Wrzesień - Listopad',
                }),
                discount: '-55%',
            },
            {
                label: formatMessage({
                    id: 'promo.birthday.discounts_06',
                    defaultMessage: 'Grudzień',
                }),
                discount: '-45%',
            },
        ],
        []
    )

    return (
        <Modal
            isOpened={isOpened}
            onClose={close}
            maxWidth={560}
            isBlur
            isMobileCentered
        >
            <ModalWrapper isFullWidth theme={darkMode}>
                <ModalHeader
                    pt={[16, 32]}
                    pr={[16, 40]}
                    pb={[16, 32]}
                    pl={[16, 40]}
                    theme={darkMode}
                >
                    <Text
                        variant="heading3"
                        color="grayscale_200"
                        style={{ width: '90%' }}
                    >
                        <FormattedMessage
                            id="promo.birthday.discounts_header"
                            defaultMessage="Zniżki na bilety do parku w urodzinowej promocji Suntago"
                        />
                    </Text>
                </ModalHeader>
                <ModalContent isFullWidth>
                    <Box mt={[4, 24]} mb={[0, 12]} isFullWidth>
                        {tabelData.map(({ label, discount }, index) => (
                            <ModalRow
                                direction="row"
                                justify="space-between"
                                isFullWidth
                                isFirst={!index}
                                isLast={index === tabelData.length - 1}
                                key={label}
                            >
                                <Text variant="bodySmall" color="grayscale_0">
                                    {label}
                                </Text>
                                <Text variant="bodySmall" color="grayscale_0">
                                    {discount}
                                </Text>
                            </ModalRow>
                        ))}
                    </Box>
                </ModalContent>
            </ModalWrapper>
        </Modal>
    )
}

export default BirthdayPromotionModal
